import axios from 'axios'
import appConfig from '@src/app.config'
import router from '../../router'

export const state = {
  currentUser: getSavedState('rosterUser') != null ? getSavedState('rosterUser') : null,
  currentAgency: getSavedState('agency') != null ? getSavedState('agency') : null
}

export const mutations = {
  SET_CURRENT_USER (state, newValue) {
    state.currentUser = newValue
  },
  SET_CURRENT_AGENCY(state, newValue) {
    state.currentAgency = newValue
  }
}

export const getters = {
  currentUser: state => state.currentUser,
  currentAgency: state => state.currentAgency,
  loggedIn(state) {
    return !!state.currentUser
  },
  inAgency(state) {
    return !!state.currentAgency
  }
}

export const actions = {

  init({ state, dispatch }) {
  },

  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
    commit('SET_CURRENT_AGENCY', null)
    removeState('rosterUser')
    removeState('agency')
    router.push({ name: 'login' })
  },

  setUser ({ commit }, user) {
    saveState('rosterUser', user)
    commit('SET_CURRENT_USER', user)
  },

  setAgency ({ commit }, agency) {
    saveState('agency', agency)
    commit('SET_CURRENT_AGENCY', agency)
  },

  loginRedirect() {
    router.push({ name: 'login' })
  },

  loginCheck ({ commit }, statusCode) {
    if (statusCode === 401) {
      router.push('./')
    }
  },

  validate({ commit, state }) {

    return axios
      .get(appConfig.apiUrl + 'user/userinfo',
      { headers: { 'Authorization': `Bearer ${state.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        const user = response.data       
        return user
      })
      .catch((error) => {
        console.log(error)
        commit('SET_CURRENT_USER', null)
        commit('SET_CURRENT_MODULE', null)
        removeState('rosterUser')
        removeState('agency')
        router.push({ name: 'login' })
        return false
      })
  },
}

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function removeState (key) {
  window.localStorage.removeItem(key)
}